import React, { createContext, useEffect, useState } from 'react';
import axios from 'axios';

const MedataContext = createContext();



function MedataProvider({ children }) {

  const [datasets, setDatasets] = useState(null);
  const [datasetsL, setDatasetsL] = useState(0);
  const [themes, setThemes] = useState([]);
  const [publishersL, setPublishersL] = useState(0);
  const [items, setItems] = useState([]);
  const [fDatasets, setFDatasets] = useState([]);
  const [boardsLength, setBoardsLength] = useState(0);
  const [downloads, setDownloads] = useState(0);
  const [visits, setVisits] = useState(0);
  const [datasetDonwloads,setDatasetDonwloads] = useState(0);

  const getViewsAndDownloads = async () => {
    const { data } = await axios.get(process.env.REACT_APP_JSON_API_GET_DATA_VIEWS_DOWNLOADS);

    var totalViews = data.data.reduce((acc, value) => {
      if (value.attributes.field_visitas) {
        return (acc + value.attributes.field_visitas)
      } else {
        return acc
      }
    }, 0)

    var totalDownloads = data.data.reduce((acc, value) => {
      if (value.attributes.field_descargas) {
        return (acc + value.attributes.field_descargas)
      } else {
        return acc
      }
    }, 0)

    setDownloads(totalDownloads)
    setVisits(totalViews)
  }

  useEffect(() => {
    async function getDatasets() {
      const { data } = await axios.get(
        `${process.env.REACT_APP_ROOT_URL}/metastore/schemas/dataset/items?show-reference-ids`
      );
      setDatasets(data);
      setDatasetsL(data.length);
    }
    async function getThemes() {
      const { data } = await axios.get(
        `${process.env.REACT_APP_ROOT_URL}/metastore/schemas/theme/items`
      );
      setThemes(data);
    }
    async function getPublishersL() {
      const { data } = await axios.get(
        `${process.env.REACT_APP_ROOT_URL}/metastore/schemas/publisher/items`
      );
      setPublishersL(data.length);
    }
    async function getBoardsLength() {
      const { data } = await axios.get(
        `${process.env.REACT_APP_ROOT_URL}/search/?publisher__name=Medellín%20en%20cifras`
      );
      if (data && data.total) {
        setBoardsLength(data.total);
      }
    }

    if (datasets === null) {
      getDatasets();
      getThemes();
      getPublishersL();
      getBoardsLength();
    }
    if (datasets) {
      const orderedDatasets = datasets.sort(function (a, b) {
        return a.title - b.title;
      });

      setFDatasets(
        orderedDatasets.length > 3
          ? orderedDatasets.slice(
            orderedDatasets.length - 3,
            orderedDatasets.length
          )
          : orderedDatasets
      );
    }
  }, [datasets]);

  useEffect(() => {
    getViewsAndDownloads()
  }, [])

  useEffect(() => {
    setItems(
      themes.map((x) => {
        let item = {
          identifier: x.identifier,
          ref: `search/?theme=${x.data}`,
          title: x.data,
        };
        return item;
      })
    );
  }, [themes]);

  return (
    <MedataContext.Provider value={{
      datasets,
      setDatasets,
      datasetsL,
      setDatasetsL,
      publishersL,
      setPublishersL,
      items,
      setItems,
      fDatasets,
      setFDatasets,
      boardsLength,
      setBoardsLength,
      downloads,
      visits,
      datasetDonwloads,
      setDatasetDonwloads
    }}>
      {children}
    </MedataContext.Provider>
  );
}

export { MedataContext, MedataProvider };
